import { Controller } from "@hotwired/stimulus"

// Two jobs, both about the jump an action makes to the next card.
//
// On arrival it flashes the card for about a second, so a screen that changed
// under the reader's hands announces itself as a new card rather than looking
// like the same one with a different message.
//
// And it lends the hidden next/from fields to the forms that two other
// controllers build in JS (action-confirm, reject-reason): those POST to the
// shared bulk endpoints, which need to know which card to open next. Copies,
// not moves, so the fields survive the first submit.
export default class extends Controller {
  static targets = ["fields"]
  static values = { arrived: Boolean }

  static HIGHLIGHT = ["ring-2", "ring-orange-400", "ring-offset-2", "ring-offset-zinc-50", "rounded-xl"]
  static HIGHLIGHT_MS = 1000

  connect() {
    if (this.arrivedValue) this.flash()
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  flash() {
    this.element.classList.add(...this.constructor.HIGHLIGHT)
    this.timer = setTimeout(
      () => this.element.classList.remove(...this.constructor.HIGHLIGHT),
      this.constructor.HIGHLIGHT_MS
    )
  }

  // Called by the JS-built forms elsewhere on the page.
  appendTo(form) {
    if (!this.hasFieldsTarget) return
    this.fieldsTarget.querySelectorAll("input").forEach((input) => form.appendChild(input.cloneNode(true)))
  }
}
